import React from 'react';
import { Field } from 'redux-form';
import FileUpload from '@material-ui/icons/FileUpload';
import Button from '@material-ui/core/Button'
import ossUpload from '../../util/ossUpload';
import {getUserInfo} from '../../util/http';

function uploadImgFile(id, input) {
    const userInfo = getUserInfo()
    return ossUpload(`${userInfo.user.name}`, id)
        .then((data) => {
            console.info(data);
            input.onChange(data.url)
        })
}
const renderUploadImg = ({id, input, label, className, required = false, meta: { touched, error }}) => (
    <div className={className} style={{display: 'inline-flex'}}>
        <input
            accept="*/*"
            id={id}
            type="file"
            onChange={() => uploadImgFile(id, input)}
            style={{display: 'none'}}
        />
        <label>
            <Button component="span" color="primary" onClick={()=>document.getElementById(id).click()}>
                {label}{required ? '*' : ''}<FileUpload />
            </Button>
            {touched && error ? error : ''}
            {input.value && <a href={`${input.value}`} target="_blank">查看图片</a>}
        </label>
    </div>   
)
export default (obj) => {
    return <Field component={renderUploadImg} {...obj} />
}


// WEBPACK FOOTER //
// ./src/uis/form/upload.js